import Link from "next/link";
import React from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";
import { giftCardRoute } from "@/utils/giftCardUtils";

export interface CheckoutCartHeaderProps {
  redirectToGiftCard: boolean;
}

export const CheckoutHeader = ({
  redirectToGiftCard,
}: CheckoutCartHeaderProps) => {
  return (
    <div
      className={[
        "flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "z-20",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        <Link href={!redirectToGiftCard ? "/" : giftCardRoute}>
          <div
            className={["flex", "flex-row", "gap-3", "items-center"].join(" ")}
          >
            <ArrowLeftIcon />

            <p className="text-[20px] font-medium text-[#373737]">Checkout</p>
          </div>
        </Link>
      </div>
    </div>
  );
};
